module.exports = __webpack_public_path__ + "static/img/icon_weibo.a63bd71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_weibo.png
// module id = WRaY
// module chunks = 1